import axios from "axios";

//Base URL WITHOUT `/api`
//const API_BASE_URL = "http://localhost:5281"; // Backend runs on port 5281

const API_BASE_URL = "https://my.fec.ai:8443"; // Backend runs on port 5281

//Create a global Axios instance with `/api` included in `baseURL`
const api = axios.create({
    baseURL: `${API_BASE_URL}/api`, // Added /api here
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
    },
    withCredentials: true,
});

//Function to dynamically set Authorization header based on JWT
export const setAuthToken = (token) => {
    if (token) {
        api.defaults.headers["Authorization"] = `Bearer ${token}`;
        localStorage.setItem("authToken", token); //Store token in local storage
    } else {
        delete api.defaults.headers["Authorization"];
        localStorage.removeItem("authToken");
    }
};

//Automatically include stored token (if available) on app load
const storedToken = localStorage.getItem("authToken");
if (storedToken) {
    setAuthToken(storedToken);
}

//Handle Unauthorized (401) responses
api.interceptors.response.use(
    (response) => response, //Return response if successful
    (error) => {
        if (error.response?.status === 401 && !window.location.pathname.includes('/login')) {
            console.error("Unauthorized! Redirecting to login...");
            setAuthToken(null);
            window.location.href = "/login"; // Redirect to login if token expires
        }
        
        // Extract detailed error message from backend exceptions
        if (error.response?.status === 500 && error.response?.data) {
            const errorData = error.response.data;
            // Check if the error comes from a .NET exception with a message
            if (typeof errorData === 'string' && 
                (errorData.includes('InvalidOperationException') || 
                 errorData.includes('Exception:'))) {
                
                // Try to extract just the error message from the stack trace
                const match = errorData.match(/Exception: (.*?)(\r?\n|$)/);
                if (match && match[1]) {
                    error.response.data = match[1].trim();
                }
            }
        }
        
        return Promise.reject(error);
    }
);

export { API_BASE_URL, api };
